"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultCookiesStore = exports.getDefaultSessionStore = exports.getDefaultMemoryStore = exports.getDefaultLocalStore = exports.StoreAsync = exports.StorageLocation = exports.Store = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
Object.defineProperty(exports, "Store", { enumerable: true, get: function () { return web_ui_framework_1.Store; } });
Object.defineProperty(exports, "StorageLocation", { enumerable: true, get: function () { return web_ui_framework_1.StorageLocation; } });
Object.defineProperty(exports, "StoreAsync", { enumerable: true, get: function () { return web_ui_framework_1.StoreAsync; } });
const getDefaultLocalStore = () => new web_ui_framework_1.Store({ storage: web_ui_framework_1.StorageLocation.Local, debug: true, prefix: '' });
exports.getDefaultLocalStore = getDefaultLocalStore;
const getDefaultMemoryStore = () => new web_ui_framework_1.Store({ storage: web_ui_framework_1.StorageLocation.Memory, debug: true, prefix: '' });
exports.getDefaultMemoryStore = getDefaultMemoryStore;
const getDefaultSessionStore = () => new web_ui_framework_1.Store({ storage: web_ui_framework_1.StorageLocation.Session, debug: true, prefix: '' });
exports.getDefaultSessionStore = getDefaultSessionStore;
const getDefaultCookiesStore = (options) => {
    let storeConfig = { storage: web_ui_framework_1.StorageLocation.Cookie, debug: true, prefix: '' };
    if (options) {
        storeConfig = { ...storeConfig, ...{ config: { ...options } } };
    }
    return new web_ui_framework_1.Store(storeConfig);
};
exports.getDefaultCookiesStore = getDefaultCookiesStore;
//# sourceMappingURL=index.js.map